import { DATA_SOURCE } from '../../core/constants/network';

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]']);

function readMode() {
    const raw = String(import.meta.env.VITE_DATA_SOURCE || DATA_SOURCE.DEMO).trim().toLowerCase();
    if (raw !== DATA_SOURCE.DEMO && raw !== DATA_SOURCE.API) {
        throw new Error(`[boot] VITE_DATA_SOURCE must be "demo" or "api", got "${raw}"`);
    }
    return raw;
}

function readEndpoint() {
    const raw = import.meta.env.VITE_API_ENDPOINT;
    if (!raw) throw new Error('[boot] missing env: VITE_API_ENDPOINT (required when VITE_DATA_SOURCE=api)');
    const parsed = new URL(raw);
    if (parsed.protocol !== 'https:' && !LOCAL_HOSTS.has(parsed.hostname)) {
        throw new Error('[boot] VITE_API_ENDPOINT must use https outside localhost');
    }
    return parsed.toString().endsWith('/') ? parsed.toString() : `${parsed.toString()}/`;
}

const mode = readMode();

export const dataSource = Object.freeze({
    mode,
    isDemo: mode === DATA_SOURCE.DEMO,
    endpoint: mode === DATA_SOURCE.API ? readEndpoint() : null,
});
